'use strict';

import Mustache from 'mustache';

/**
 * This module handles rendering templates
 * - Fetching the correct template
 * - Handling possible subtemplates
 * - Rendering
 */
class TemplateHelper {
  constructor(options) {
    const defaults = {
      selectorPrefix: 'mustache-'
    };

    this.settings = Object.assign({}, defaults, options);
    this.s = this.settings;
  }

  /**
   * Get template from DOM
   *
   * @param  {string} name  The name of the template
   * @return {string}       The template code
   */
  _getTemplate(name) {
    return document.getElementById(this.s.selectorPrefix + name).innerHTML;
  }

  /**
   * Render template
   *
   * @param {string}      templateName The name of the template to use for rendering
   * @param {Object}      data         Data to use
   * @param {HTMLElement} parent       jQuery-object of the parent element to which the data is inserted
   * @param {string}      placement    Where to place new html.
   *                                   - 'replace' replaces parent html with new html
   *                                   - 'append' appends new html as the last child of the parent
   *                                   - 'prepend' prepends new html as the first child of the parent
   *                                   - 'none' returns the rendered HTML without inserting anything into the DOM
   * @param {Array} partialNames   A list of subtemplate names
   *
   * @returns {HTMLElement|String} - Reference to the newly created element, or the HTML string
   */
  render(templateName, data, parent, placement, partialNames = []) {
    // TODO: fetch all templates to a subtemplate object and pass that to Mustache.render as third param
    // For now this has not been needed though. Implement when it becomes necessary.

    if (typeof placement !== 'string') {
      placement = 'replace';
    }
    const partials = {};
    partialNames.forEach(name => {
      partials[name] = this._getTemplate(name);
    }, this);
    let template = this._getTemplate(templateName);
    let html = Mustache.render(template, data, partials).trim();
    let ref;
    switch (placement) {
      case 'none':
        return html;
      case 'replace':
        parent.innerHTML = html;
        ref = parent.firstChild;
        break;
      case 'append':
        parent.insertAdjacentHTML('beforeend', html);
        ref = parent.lastChild;
        break;
      case 'prepend':
        parent.insertAdjacentHTML('afterbegin', html);
        ref = parent.firstChild;
        break;
    }
    return ref;
  }
}

export default TemplateHelper;
